/**
 * @file complete-profile.service.ts
 */
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { environment } from '@root/environments/environment';
import { HttpClient } from '@angular/common/http';
import { RequestRegisterSso, SSOMemberProfile } from '@models/interfaces';
import { APIConstants } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class CompleteProfileService {
  ssoToken = '';
  user!: SSOMemberProfile;

  constructor(
    private readonly http: HttpClient,
  ) {}

  public registerSsoMember(ssoRegisterRequest: RequestRegisterSso): Observable<any> {
    const apiBaseUrl: string = environment.hostURL;
    return this.http
      .post(
        `${apiBaseUrl}${APIConstants.MEMBER_SERVICES.COMPLETE_SSO_PROFILE}`,
        ssoRegisterRequest,
        { observe: 'response' }
      )
      .pipe(take(1));
  }
}
